import React, { useEffect, useState } from 'react'
import { RiListRadio, RiDeleteBin2Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import toast from 'react-hot-toast';
import { addData, deleteData, editData, getData } from '../../controllers/flyerManagement.controller';

const FlyerManagement = () => {

    const [image, setImage] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [data, setData] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Submitted: ", formData);

    };



    const [formData, setFormData] = useState({
        title: "",
        // subtitle: "",
        file: null,
    });






    const handleRemoveImage = () => {
        setImage(null); // Reset the image state
        setFormData({ ...formData, file: null });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };



    const fetchData = async () => {
        try {
            const res = await getData({});
            console.log("res => ", res);

            if (res.status === 200) {
                const apiData = res?.data?.data;
                const tableData = apiData?.map((d) => ({
                    id: d.id,
                    title: d.title,
                    // subtitle: d.subtitle,
                    image: d.image_url || "",
                }));
                setData(tableData);

                if (tableData.length > 0) {
                    const firstItem = tableData[0];
                    setSelectedRowId(firstItem.id);
                    setFormData({
                        title: firstItem.title,
                        // subtitle: firstItem.subtitle,
                        file: null,
                    });
                    setImage(firstItem.image);
                }
            } else {
                toast.error("Failed to fetch data.");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error("Something went wrong while fetching data.");
        }
    };
    useEffect(() => {
        fetchData();
    }, []);



    // const handleImageChange = (event) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         setImage(URL.createObjectURL(file));
    //         setFormData({ ...formData, file });
    //     } else {
    //         setFormData({ ...formData, file: null });
    //     }
    // };


    // const handleRemoveImage = () => {
    //     setImage(null); // Reset the image state
    // };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
            setSelectedFile(file)
        } else setSelectedFile(null)

    };


      // edit
      const editBtn = async () => {
        try {
            const { title, file } = formData;

            if (!title ) {
                toast.error("Please fill in all the required fields and upload a document.");

                return;
            }

            toast.loading("Submitting your data...");


            const res = await editData({
                id: selectedRowId,
                title,              
                file
            });

            const message = res.data.message;
            toast.dismiss();

            if (res.status === 200) {
                toast.success(message);
                setFormData({
                    title: "",                   
                    file: null,

                });

                document.getElementById("modal-edit").close()
                fetchData()
            } else {
                toast.error(message || "Failed to add research data.");
            }
        } catch (error) {
            toast.dismiss();
            console.error("Error adding research data:", error);


            const message = error?.response?.data?.message || "Something went wrong!";
            toast.error(message);
        }
    };


    const deleteBtn = async () => {
        try {
            if (selectedRowId) {
                toast.loading("Please wait...");
                const res = await deleteData({ id: selectedRowId })
                const message = res.data.message;
                toast.dismiss();
                if (res.status === 200) {
                    toast.success(message);
                    fetchData()
                    setSelectedRowId(null)
                    document.getElementById("modal-delete").close()
                } else {
                    toast.error(message);
                }
            }
        } catch (error) {
            console.error(error);
            const message = error?.response?.data?.error || "Something went wrong!";
            toast.dismiss();
            toast.error(message);
        }
    }


    const addBtn = async () => {
        try {
            const { title,  file } = formData;

            if (!title ||  !file) {
                toast.error("Please fill in all the required fields and upload a document.");
                return;
            }

            toast.loading("Submitting your data...");


            const res = await addData({
                title,
               
                file,

            });

            const message = res.data.message;
            toast.dismiss();

            if (res.status === 200) {
                toast.success(message);
                setFormData({
                    
                    title: "",
                    file: null,

                });

                fetchData()
            } else {
                toast.error(message || "Failed to add research data.");
            }
        } catch (error) {
            toast.dismiss();
            console.error("Error adding research data:", error);


            const message = error?.response?.data?.message || "Something went wrong!";
            toast.error(message);
        }
    };

    return (
        <div>
            <div>
                <div className="p-6">

                    <div className='flex text-xl gap-10 items-center'>
                      
                    </div>

                    <div className="container">
                        <div className="p-6  mx-auto bg-white rounded-lg shadow-md">


                            <form onSubmit={handleSubmit}>
                                <h1 className="text-xl font-bold text-gray-700 mb-4"> Flyer Management Section</h1>

                                <div className="grid grid-cols-2 gap-6">

                                    <div className="mb-6">
                                      
                                        <div className="mt-2 flex flex-col items-center justify-center border-dashed border-2 border-gray-300 rounded-lg h-36">
                                            {formData.file ? (
                                                <>
                                                    <img
                                                        src={typeof formData.file === "string" ? formData.file : URL.createObjectURL(formData.file)}
                                                        alt="Uploaded Preview"
                                                        className="h-28 w-auto object-contain"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => setFormData({ ...formData, file: null })}
                                                        className="text-red-500 mt-2"
                                                    >
                                                        Remove Image
                                                    </button>
                                                </>
                                            ) : (
                                                <div className="text-gray-500">
                                                    <div className="flex justify-center">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            strokeWidth={1.5}
                                                            stroke="currentColor"
                                                            className="w-10 h-10"
                                                        >
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                                        </svg>
                                                    </div>
                                                    <p>Drag and drop image here</p>
                                                    {/* <p>or</p> */}
                                                    <p className="text-sm text-center text-gray-400">
                        Any size of image, will automatically adjust to the frame 
                        </p>
                                                    <div className="flex gap-10">
                                                        <label className="px-4 py-2 text-[#92288C] rounded-md cursor-pointer border-2 border-[#92288C] hover:bg-[#92288C] hover:text-white">
                                                            <input
                                                                type="file"
                                                                accept=".jpg, .png"
                                                                onChange={(e) => setFormData({ ...formData, file: e.target.files[0] })}
                                                                className="hidden"
                                                            />
                                                            Browse image
                                                        </label>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>


                                    <div className="mb-4 w-full text-left">
                                        <label className="block text-gray-600 font-medium mb-1">
                                            Title
                                        </label>
                                        <textarea
                                            id="title"
                                            name="title"
                                            // value={formData.title}
                                            onChange={handleChange}
                                            rows="4"
                                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:[#92288C]"
                                        />
                                    </div>
                                </div>
                                <button
                                    className="px-4 py-2 bg-[#92288C] text-white rounded-md hover:bg-[#7a2175] justify-end"
                                onClick={() => addBtn()}
                                >
                                    Add
                                </button>
                            </form>
                        </div>

                        <div className="p-6 mx-auto bg-white rounded-lg shadow-md mt-10">


                            <table className="w-full border-collapse bg-white rounded-lg shadow-md">
                                <thead>
                                    <tr className="bg-gray-100 text-[#4B465C]">
                                        <th className="py-2 px-4 w-1/4 text-center">Title</th>


                                        <th className="py-2 px-4 w-1/4 text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={item.id} className="border-b hover:bg-gray-50">

                                         


                                            <td className="py-2 px-4 text-center">{item.title}</td>


                                            <td className="py-2 px-4 text-center">
                                                <div className="flex justify-center gap-4">
                                                    <button
                                                        onClick={() => {
                                                            setSelectedRowId(item.id)
                                                            document.getElementById("modal-delete").showModal();
                                                        }}
                                                        className="flex items-center px-3 py-1 bg-[#A8AAAE14] text-[#A8AAAE] border border-[#A8AAAE] rounded-md hover:bg-gray-300"
                                                    >
                                                        Delete
                                                        <RiDeleteBin2Line className="ml-2" />
                                                    </button>

                                                    <button
                                                        onClick={() => {
                                                            setSelectedRowId(item.id)
                                                            setImage(item.image)

                                                            document.getElementById("modal-editPartnDetails").showModal();
                                                        }}
                                                        className="px-3 py-1 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md flex items-center gap-1">
                                                        Edit
                                                        <FiEdit />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>



                        </div>


                        <dialog
                            id="modal-delete"
                            className="modal modal-bottom sm:modal-middle inset-0 z-50 rounded-lg"
                        >

                            <div className="relative bg-white rounded-lg shadow-lg p-6 max-w-lg w-full mx-auto z-10">
                                <div className="text-center">
                                    <h2 className="text-xl font-bold text-gray-900">
                                        Delete
                                    </h2>
                                    <p className="text-gray-500 font-bold">
                                        Are you sure?
                                    </p>
                                </div>


                                <div className="mt-4 flex justify-center space-x-4">
                                    <button
                                        onClick={() => {
                                            setSelectedRowId(null)
                                            document.getElementById("modal-delete").close()
                                        }}
                                        className="rounded-lg hover:bg-gray-200 transition active:scale-95 hover:shadow-lg px-6 py-3 bg-gray-200 text-gray-600"
                                    >
                                        No
                                    </button>
                                    <button
                                      onClick={async () => { deleteBtn(); }}
                                        className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </dialog>


                        <dialog
                            id="modal-editPartnDetails"
                            className="modal modal-bottom xl:modal-middle inset-0 z-50 rounded-lg w-[500px]"
                        >
                            <div className="p-6 max-w-lg w-full mx-auto">
                                <h1 className="text-xl font-bold text-gray-700 mb-4">Edit Flyer</h1>

                                <div className="grid grid-cols-2 gap-6">
                                    {/* Image Upload Section */}
                                    <div className="mb-6">
                                        <h1 className="block text-black font-medium mb-2 text-[18px]">
                                            Flyer Image
                                            <b className="text-[#4B465C]">(Accept: .jpg, .png)</b>
                                        </h1>
                                        <div className="mt-2 flex flex-col items-center justify-center border-dashed border-2 border-gray-300 rounded-lg h-36">
                                            {image ? (
                                                <>
                                                    <img
                                                        src={image}
                                                        alt="Uploaded Preview"
                                                        className="h-28 w-auto object-contain"
                                                    />
                                                    <button
                                                        onClick={handleRemoveImage}
                                                        className="px-4 py-2 mt-2 bg-[#EA5455] text-white rounded-md hover:bg-red-600"
                                                    >
                                                        Remove Image
                                                    </button>
                                                </>
                                            ) : (
                                                <div className="text-gray-500">
                                                    <div className="flex justify-center">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            strokeWidth={1.5}
                                                            stroke="currentColor"
                                                            className="w-10 h-10"
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                d="M12 4.5v15m7.5-7.5h-15"
                                                            />
                                                        </svg>
                                                    </div>
                                                    <p>Drag and drop image here</p>
                                                    {/* <p>or</p> */}
                                                    <p className="text-sm text-center text-gray-400">
                        Any size of image, will automatically adjust to the frame 
                        </p>
                                                    <label className="px-4 py-2 text-[#92288C] rounded-md cursor-pointer border-2 border-[#92288C] hover:bg-[#92288C] hover:text-white">
                                                        <input
                                                            type="file"
                                                            accept=".jpg, .png"
                                                            onChange={(e) => {
                                                                const file = e.target.files[0];
                                                                if (file) {
                                                                    setSelectedFile(file);
                                                                    const reader = new FileReader();
                                                                    reader.onload = (event) => setImage(event.target.result);
                                                                    reader.readAsDataURL(file);
                                                                }
                                                            }}
                                                            className="hidden"
                                                        />
                                                        Browse Image
                                                    </label>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Title Input Section */}
                                    <div>
                                        <div className="mb-4 w-full text-left">
                                            <label className="block text-gray-600 font-medium mb-1">Title</label>
                                            <input
                                                value={formData.title}
                                                onChange={handleChange}
                                                name="title"
                                                type="text"
                                                id="title"
                                                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#92288C]"
                                            />
                                        </div>
                                    </div>
                                </div>


                                <div className="flex justify-between">

                                    <button
                                        className="px-4 py-2 text-gray-500 border border-gray-300 rounded-md"
                                        onClick={() => {
                                            setSelectedRowId(null);
                                            setImage(null);
                                            setFormData({
                                                title: "",
                                                file: null,
                                            });
                                            document.getElementById("modal-editPartnDetails").close();
                                        }}
                                    >
                                        Back
                                    </button>


                                    <button
                                        className="px-4 py-2 bg-[#92288C] text-white rounded-md hover:bg-[#7a2175]"
                                        // onClick={(e) => {
                                        //     handleSubmit(e);
                                        //     document.getElementById("modal-editPartnDetails").close();
                                        // }}
                                        onClick={() => editBtn()}
                                    >
                                        Edit Slide
                                    </button>
                                </div>
                            </div>
                        </dialog>



                    </div>
                </div>
            </div>
        </div>
    )
}

export default FlyerManagement
